export const PATIENT_PORTAL_EVENT_SOURCE_IDENTIFIER = "patient";

export type OpenModalTrigger = "page load" | "user action";

export enum UserActionEvent {
    AmplitudeVariantExposure = "$exposure",
    AppointmentPublicReviewClicked = "Appointment Public Review Clicked",
    AppointmentReviewInitiated = "Appointment Review Initiated",
    BookingFlowAppointmentBooked = "Booking Flow Appointment Booked",
    BookingFlowClinicSelected = "Booking Flow Clinic Selected",
    BookingFlowClinicListFilterChanged = "Booking Flow Clinic List Filter Changed",
    BookingFlowClinicListViewed = "Booking Flow Clinic List Viewed",
    BookingFlowConsultationSelected = "Booking Flow Consultation Selected",
    BookingFlowInitiated = "Booking Flow Initiated",
    BookingFlowLabSelected = "Booking Flow Lab Selected",
    BookingFlowLocationPopupClosed = "Booking Flow Location Popup Closed",
    BookingFlowLocationPopupLabChanged = "Booking Flow Location Popup Lab Changed",
    BookingFlowLocationPopupLocationChanged = "Booking Flow Location Popup Location Changed",
    BookingFlowLocationPopupPopoverClicked = "Booking Flow Location Popup Popover Clicked",
    BookingFlowLocationPopupSubmitted = "Booking Flow Location Popup Submitted",
    BookingFlowLocationPopupToggleClicked = "Booking Flow Location Popup Toggle Clicked",
    BookingFlowLocationPopupViewed = "Booking Flow Location Popup Viewed",
    BookingFlowMedicalEvaluationSubmitted = "Booking Flow Medical Evaluation Submitted",
    BookingFlowPaymentCompleted = "Booking Flow Payment Completed",
    BookingFlowPrivacyConsentAccepted = "Booking Flow Privacy Consent Accepted",
    BookingFlowPrivacyConsentDeclined = "Booking Flow Privacy Consent Declined",
    BookingFlowPersonalFormFilled = "Booking Flow Personal Form Filled",
    BookingFlowRecommendedTestsSelected = "Booking Flow Recommended Tests Selected",
    ClinicListFilterChanged = "Clinic List Filter Changed",
    ClinicListSelected = "Clinic List Selected",
    ClinicListViewed = "Clinic List Viewed",
    EmailVerificationCompleted = "Email Verification Completed",
    LocationPopupClosed = "Location Popup Closed",
    LocationPopupLabChanged = "Location Popup Lab Changed",
    LocationPopupLocationChanged = "Location Popup Location Changed",
    LocationPopupPopoverClicked = "Location Popup Popover Clicked",
    LocationPopupSubmitted = "Location Popup Submitted",
    LocationPopupToggleClicked = "Location Popup Toggle Clicked",
    LocationPopupViewed = "Location Popup Viewed",
    LoginCompleted = "Login Completed",
    LoginInitiated = "Login Initiated",
    MFASetupInitiated = "MFA Setup Initiated",
    PasswordReset = "Password Reset",
    PhoneVerificationCompleted = "Phone Verification Completed",
    ProfileUpdated = "Profile Updated",
    ScreeningAppointmentBooked = "Screening Appointment Booked",
    ScreeningAppointmentCancelled = "Screening Appointment Cancelled",
    ScreeningAppointmentLabSelection = "Screening Appointment Lab Selection",
    ScreeningAppointmentRescheduled = "Screening Appointment Rescheduled",
    ScreeningInformationSubmitted = "Screening Information Submitted",
    ScreeningMedicalEvaluationSubmitted = "Screening Medical Evaluation Submitted",
    ScreeningPaymentSubmitted = "Screening Payment Submitted",
    ScreeningPrepAppointmentBooked = "Screening Prep Appointment Booked",
    ScreeningPrepAppointmentCancelled = "Screening Prep Appointment Cancelled",
    ScreeningPrepAppointmentDeclined = "Screening Prep Appointment Declined",
    ScreeningPrivacyConsentAccepted = "Screening Privacy Consent Accepted",
    ScreeningPrivacyConsentDeclined = "Screening Privacy Consent Declined",
    ScreeningRequestedInitiated = "Screening Request Initiated",
    SignUpCompleted = "Sign Up Completed",
    SignUpInitiated = "Sign Up Initiated",
    WalletCheckoutCancelled = "Wallet Checkout Cancelled",
    WalletCheckoutClicked = "Wallet Checkout Clicked",
    WalletCheckoutConfirmed = "Wallet Checkout Confirmed",
}
